import { useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { dataLoadToastId, loadFailMessage } from "../utils/onboardingDataLoadGate";

/**
 * Auto-errors when any tracked data load transitions to `error`.
 *
 * dataLoads shape: { [key: string]: { field: string, status: 'idle'|'loading'|'success'|'error' } }
 */
export function useDataLoadErrorToasts(dataLoads) {
    const prevRef = useRef({});

    useEffect(() => {
        const prev = prevRef.current || {};
        const next = dataLoads || {};

        for (const key of Object.keys(next)) {
            const cur = next[key];
            const was = prev[key];

            const curStatus = cur?.status;
            const wasStatus = was?.status;

            if (curStatus === "error" && wasStatus !== "error" && cur?.field) {
                toast.error(loadFailMessage(cur.field), {
                    toastId: dataLoadToastId("error", cur.field)
                });
            }
        }

        prevRef.current = next;
    }, [dataLoads]);
}
